import { CandidateStatus, useToggleShortlistCandidate } from '~/domain/PermanentJobs';
import { OutlineBookmarkIcon, SolidBookmarkIcon } from '@tempmee/react-icons';
import { firePermCandidateListShortlistClicked } from '~/posthogs/events';
import { colors } from '@tempmee/tailwind';

interface IShortlistCellProps {
  candidateId: string;
  isShortlisted: boolean;
  officeStatus: CandidateStatus;
  jobPostingId: string;
}

export const ShortlistCell = ({
  candidateId,
  isShortlisted,
  officeStatus,
  jobPostingId,
}: IShortlistCellProps) => {
  const { mutate: doShortlistCandidate, isPending: isShortlistCandidatePending } =
    useToggleShortlistCandidate({ candidateId, isShortlisted });

  const isHired = officeStatus === CandidateStatus.Hired;
  const isRejected = officeStatus === CandidateStatus.Rejected;

  const canShortlist = !isHired && !isRejected;

  if (!canShortlist) {
    return null;
  }

  return (
    <button
      data-testid="shortlist-button"
      aria-label={isShortlisted ? 'Remove from shortlist' : 'Add to shortlist'}
      aria-pressed={isShortlisted}
      disabled={isShortlistCandidatePending}
      style={{ background: 'transparent' }}
      onClick={(e) => {
        e.stopPropagation();
        firePermCandidateListShortlistClicked({
          postingId: jobPostingId,
          isShortlisted: !isShortlisted,
        });
        doShortlistCandidate();
      }}
    >
      {isShortlisted ? (
        <SolidBookmarkIcon color={colors.secondary[500]} />
      ) : (
        <OutlineBookmarkIcon color={colors.secondary[500]} />
      )}
    </button>
  );
};
